module.exports = __webpack_public_path__ + "static/media/video_3.176cdce2.png";